@if (detail) {
    <tec-aside-layout back backAction="emit" (backEvent)="goBack($event)">
        <ng-container aside>
            <app-process-detail-aside
                [detail]="detail"
                [fullName]="fullName"
                [menuOptions]="getDetailMenuOptions()"
                [menuDisabled]="downloadActive() === 'summary' || downloadActive() === 'signed'"
                [identityCurlPath]="processCurlPath('/identity')"
                [showEditIdentity]="showEditIdentity"
                (menuAction)="detailMenuChange($event)"
                (identityMenuAction)="detailMenuChange($event.action, $event.optionsSelected)"
                (editIdentity)="openEditIdentity()"
            />
        </ng-container>
        <ng-container content>
            <app-process-detail-media-previews
                [detail]="detail"
                [loading]="isMediaPreviewsLoading()"
                (mediaPreviewClick)="showViewMedia($event)"
            />

            @if (successActionMsg) {
                <tec-alert
                    status="success"
                    [msg]="successActionMsg"
                    (closeAlert)="successActionMsg = ''"
                ></tec-alert>
            }

            @if (errorActionMsg) {
                <tec-alert
                    status="error"
                    [msg]="errorActionMsg"
                    (closeAlert)="errorActionMsg = ''"
                ></tec-alert>
            }

            <div class="item-group">
                <tec-tabs [tabs]="tabs" (tabSelected)="tabSelected($event)"></tec-tabs>
                <!-- TAB: OPERACIONES -->
                @if (tabs.length && tabs[0].selected) {
                    <!-- RESULT -->
                    @if (shouldShowResultTile()) {
                        @if (isResultTileLoading()) {
                            <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
                        } @else {
                            <app-detail-result-tile [processDetail]="detail" />
                        }
                    }

                    <!-- TIMELINE -->
                    <tec-tile [title]="'PROCESSES.DETAIL.TIMELINE' | translate" icon="icon-pipeline">
                        <ng-container actions>
                            <app-developer-curl-button
                                ngProjectAs="tec-button-icon"
                                [path]="processCurlPath('/operations')"
                                titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATIONS"
                            />
                        </ng-container>
                        <tec-timeline
                            [timelineItems]="detail?.timeline"
                            [startTime]="detail.general?.init_operation | safeDate: 'HH:mm:ss'"
                            [endTime]="detail.general?.end_operation | safeDate: 'HH:mm:ss'"
                        ></tec-timeline>
                    </tec-tile>

                    <div class="collapse-group">
                        <!-- TFA (NIF-204) -->
                        @if (detail.data?.TFA) {
                            <app-operation-detail-tfa
                                [operation]="detail.data.TFA"
                                [processUuid]="id"
                                [expanded]="expandedOperation === OPERATION_TYPE.TFA"
                                (toggleCollapse)="toggleCollapse(OPERATION_TYPE.TFA, $event)"
                            />
                        }

                        <!-- FORM -->
                        @if (detail.data?.FORM) {
                            <app-operation-detail-form
                                [operation]="detail.data.FORM"
                                [processUuid]="id"
                                [loading]="isOperationLoading(OPERATION_TYPE.FORM)"
                                [contentReady]="isOperationContentReady(OPERATION_TYPE.FORM)"
                                [expanded]="expandedOperation === OPERATION_TYPE.FORM"
                                (toggleCollapse)="toggleCollapse(OPERATION_TYPE.FORM, $event)"
                            />
                        }

                        <!-- OCR -->
                        @if (detail.data?.OCR) {
                            <app-operation-detail-ocr
                                [operation]="detail.data.OCR"
                                [processUuid]="id"
                                [processDetail]="detail"
                                [validation]="detail?.general?.validation"
                                [loading]="isOperationLoading(OPERATION_TYPE.OCR)"
                                [contentReady]="isOperationContentReady(OPERATION_TYPE.OCR)"
                                [expanded]="expandedOperation === OPERATION_TYPE.OCR"
                                [fieldHistoryByKey]="fieldHistoryByKey()"
                                [showUpdateIdentityFromOcr]="showUpdateIdentityFromOcr"
                                [updateIdentityFromOcrLoading]="updateIdentityFromOcrLoading"
                                (toggleCollapse)="toggleCollapse(OPERATION_TYPE.OCR, $event)"
                                (identityMenuAction)="detailMenuChange($event.action, $event.optionsSelected)"
                                (updateIdentityFromOcr)="confirmSyncIdentityFromOcr()"
                            />
                        }

                        <!-- POL -->
                        @if (detail.data?.POL) {
                            <app-operation-detail-pol
                                [operation]="detail.data.POL"
                                [processUuid]="id"
                                [validation]="detail?.general?.validation"
                                [loading]="isOperationLoading(OPERATION_TYPE.POL)"
                                [contentReady]="isOperationContentReady(OPERATION_TYPE.POL)"
                                [expanded]="expandedOperation === OPERATION_TYPE.POL"
                                (toggleCollapse)="toggleCollapse(OPERATION_TYPE.POL, $event)"
                            />
                        }

                        <!-- DOCUMENTS / EVALUATION / ATTORNEY_POWERS: orden = Object.keys (mismo que timeline) -->
                        @for (opKey of documentsEvaluationCollapseKeys; track opKey) {
                            @switch (opKey) {
                                @case (OPERATION_TYPE.DOCUMENTS) {
                                    <app-operation-detail-documents
                                        [operation]="detail.data.DOCUMENTS"
                                        [processUuid]="id"
                                        [expanded]="expandedOperation === OPERATION_TYPE.DOCUMENTS"
                                        (toggleCollapse)="toggleCollapse(OPERATION_TYPE.DOCUMENTS, $event)"
                                    />
                                }
                                @case (OPERATION_TYPE.EVALUATION) {
                                    <app-operation-detail-financial-evaluation
                                        [operation]="detail.data.EVALUATION"
                                        [processUuid]="id"
                                        [expanded]="expandedOperation === OPERATION_TYPE.EVALUATION"
                                        [loading]="isOperationLoading(OPERATION_TYPE.EVALUATION) && !isOperationContentReady(OPERATION_TYPE.EVALUATION)"
                                        (toggleCollapse)="toggleCollapse(OPERATION_TYPE.EVALUATION, $event)"
                                    />
                                }
                                @case (OPERATION_TYPE.ATTORNEY_POWERS) {
                                    <app-operation-detail-financial-evaluation
                                        [operation]="detail.data.ATTORNEY_POWERS"
                                        [processUuid]="id"
                                        [expanded]="expandedOperation === OPERATION_TYPE.ATTORNEY_POWERS"
                                        [loading]="isOperationLoading(OPERATION_TYPE.ATTORNEY_POWERS) && !isOperationContentReady(OPERATION_TYPE.ATTORNEY_POWERS)"
                                        (toggleCollapse)="toggleCollapse(OPERATION_TYPE.ATTORNEY_POWERS, $event)"
                                    />
                                }
                            }
                        }
                    </div>
                }

                <!-- TAB: CHECKS -->
                @if (tabs.length && tabs[1].selected) {
                    @if (isTabLoading(TAB_PROCESS.CHECKS)) {
                        <!-- SLOT_LOADING_CHECKS -->
                        <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
                    } @else if (isTabContentReady(TAB_PROCESS.CHECKS) && detail) {
                        <app-process-checks-panels
                            [detail]="detail"
                            [showDeveloperCurl]="true"
                            [processUuid]="id"
                        />
                    }
                }

                <!-- TAB: ACTIVITY -->
                @if (tabs.length && tabs[2].selected) {
                    @if (isTabLoading(TAB_PROCESS.ACTIVITY)) {
                        <!-- SLOT_LOADING_ACTIVITY -->
                        <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
                    } @else if (isTabContentReady(TAB_PROCESS.ACTIVITY)) {
                        <app-list-operations-activity
                            [data]="detail?.activity"
                            [logs_url]="detail?.logs_url"
                            [curlPath]="processCurlPath('/activity')"
                        />
                    }
                }

                <!-- TAB: DETAIL -->
                @if (tabs.length && tabs[3].selected) {
                    @if (isTabLoading(TAB_PROCESS.DETAILS)) {
                        <!-- SLOT_LOADING_DETAILS -->
                        <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
                    } @else if (isTabContentReady(TAB_PROCESS.DETAILS)) {
                    <div class="layout--60-40">
                        <div class="layout__column">
                            <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate" icon="icon-capture-popup">
                                <ng-container actions>
                                    <app-developer-curl-button
                                        ngProjectAs="tec-button-icon"
                                        [path]="processCurlPath('/sections/details')"
                                        titleKey="PROCESSES.CURL_MODAL.TITLE_SECTION_DETAILS"
                                    />
                                </ng-container>
                                <div class="grid grid-i2">
                                    <tec-info-group class="info-group-uuid" [label]="'PROCESSES.DETAIL.ID_PROCESS_FULL' | translate">
                                        <app-uuid-display [uuid]="detail?.process_uuid" />
                                    </tec-info-group>
                                    <tec-info-group [label]="'PROCESSES.DETAIL.VERIFICATION' | translate">
                                        <tec-tag [label]="`PROCESSES.DETAIL.${detail?.general?.validation === 'auto' ? 'AUTOMATIC' : 'MANUAL'}` | translate"></tec-tag>
                                    </tec-info-group>
                                    <tec-info-group [label]="'PROCESSES.DETAIL.WORKFLOW' | translate">
                                        @if (detail?.general?.profile?.alias && detail?.general?.profile?.uuid && rolePermissions.canViewWorkflowDetail()) {
                                            <tec-link [href]="'/workflows/detail/' + detail?.general?.profile?.uuid">{{ detail?.general?.profile?.alias || ('GENERAL.NOT_AVAILABLE' | translate) }}</tec-link>
                                        } @else {
                                            <span>{{ detail?.general?.profile?.alias || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                                        }
                                    </tec-info-group>
                                    @if (rolePermissions.isSuperadmin()) {
                                        <tec-info-group [label]="'PROCESSES.DETAIL.AUTH_ORIGIN' | translate">
                                            <span>{{ authOriginLabel() }}</span>
                                        </tec-info-group>
                                    }
                                    @if (detail?.related_processes?.length) {
                                        <tec-info-group [label]="'PROCESSES.DETAIL.RELATED_PROCESSES' | translate">
                                            <div class="info-group">
                                                @for (rel of detail?.related_processes; track rel.uuid) {
                                                    <tec-link
                                                        [href]="`/processes/detail/${rel.uuid}`"
                                                        [label]="processHelper.truncateUUID(rel.uuid)"
                                                    />
                                                }
                                            </div>
                                        </tec-info-group>
                                    }
                                </div>
                                <tec-divider></tec-divider>
                                <div class="grid grid-i2">
                                    <tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
                                        <tec-icon name="icon-calendar"></tec-icon>
                                        <span>{{( detail?.general?.init_operation | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                                    </tec-info-group>
                                    <tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
                                        <tec-icon name="icon-calendar"></tec-icon>
                                        <span>{{ (detail?.general?.end_operation | safeDate: 'dd/MM/yyyy - HH:mm') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                                    </tec-info-group>
                                </div>
                            </tec-tile>
                            <tec-tile
                                appProcessDevicesTile
                                #devicesTile="processDevicesTile"
                                [title]="'PROCESSES.DETAIL.DEVICES' | translate"
                                icon="icon-smartphone"
                                [devices]="detail.general?.devices || []"
                                [locations]="detail.general?.location || []"
                                [blockedIps]="detail.locks?.blocked_ips || []"
                                [canBlockIp]="rolePermissions.canBlockPersons()"
                                [canUnblockIp]="rolePermissions.canUnblockPersons()"
                                (viewDeviceDetails)="openUserAgentModal($event)"
                                (blockUnlockClick)="onDevicesBlockUnlock($event)"
                            >
                                <ng-container actions>
                                    <app-developer-curl-button
                                        ngProjectAs="tec-button-icon"
                                        [path]="processCurlPath('/sections/device')"
                                        titleKey="PROCESSES.CURL_MODAL.TITLE_SECTION_DEVICE"
                                    />
                                </ng-container>
                                @if (devicesTile.locations?.length) {
                                    <div class="process-devices-tile__map">
                                        <app-maps-localization
                                            [locations]="devicesTile.locations"
                                            [devices]="devicesTile.devices"
                                            [blockedIps]="devicesTile.blockedIps"
                                            [canBlockIp]="devicesTile.canBlockIp"
                                            [canUnblockIp]="devicesTile.canUnblockIp"
                                            (viewDeviceDetails)="devicesTile.onViewDetails($event)"
                                            (blockUnlockClick)="devicesTile.blockUnlockClick.emit($event)"
                                        />
                                    </div>
                                }
                                @if (devicesTile.deviceCards.length) {
                                    <tec-item-group>
                                        @for (card of devicesTile.deviceCards; track card.id) {
                                            <div
                                                class="process-devices-tile__device"
                                                (click)="devicesTile.onDeviceCommentClick($event, card)"
                                            >
                                                <tec-comment layout="thread" [comments]="[card.comment]" />
                                            </div>
                                        }
                                    </tec-item-group>
                                } @else {
                                    <tec-empty-state [title]="devicesTile.emptyTitleKey | translate" size="sm" />
                                }
                            </tec-tile>
                            </div>
                            <div class="layout__column">
                                <tec-stats
                                    [title]="'PROCESSES.DETAIL.DURATION' | translate"
                                    [description]="detail?.general?.average_workFlow ? ('PROCESSES.DETAIL.AVG_DURATION' | translate: {avgTime: detail?.general?.average_workFlow}) : ''"
                                    [value]="(detail?.general?.total_time?.toString() + 's') || ('GENERAL.NOT_AVAILABLE' | translate)"
                                    [tagRounded]="tagRoundedByProcess"
                                    [size]="'default'"
                                >
                                    <app-developer-curl-button
                                        ngProjectAs="tec-button-icon"
                                        [path]="processCurlPath('/sections/duration')"
                                        titleKey="PROCESSES.CURL_MODAL.TITLE_SECTION_DURATION"
                                    />
                                </tec-stats>
                                <div class="item-group">
                                    @if (processHelper.dataJsonMenuOpt.length > 0) {
                                        <tec-item
                                            [title]="'PROCESSES.DETAIL.JSON' | translate"
                                            [tagImage]="{icon: 'icon-back-ajax-result', status:'level'}"
                                            [clickeable]="false">
                                            <tec-menu
                                                [options]="processHelper.dataJsonMenuOpt"
                                                (valueChange)="dataJsonMenuChange($event)">
                                                <tec-button-icon [icon]="'icon-more'" [type]="'default'"></tec-button-icon>
                                            </tec-menu>
                                        </tec-item>
                                    }
                                    @if (messagesCount() > 0) {
                                        <tec-item
                                            [title]="'PROCESSES.DETAIL.MESSAGES_SENT' | translate"
                                            [tagImage]="{icon: 'icon-message-circle', status:'control'}"
                                            [clickeable]="false"
                                        >
                                            <app-developer-curl-button
                                                ngProjectAs="tec-button-icon"
                                                [path]="processCurlPath('/sections/sms')"
                                                titleKey="PROCESSES.CURL_MODAL.TITLE_SECTION_SMS"
                                            />
                                            <tec-badge
                                                [label]="messagesCount().toString()"
                                                type="square"
                                            />
                                            <tec-button-icon
                                                size="md"
                                                icon="icon-eye"
                                                (clickEvent)="openSentMessagesModal()"
                                            />
                                        </tec-item>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </ng-container>
    </tec-aside-layout>
}

@if (resourceError) {
    <app-detail-resource-error
        [kind]="resourceError.kind"
        [titleKey]="resourceError.titleKey"
        [descriptionKey]="resourceError.descriptionKey"
        [showRetry]="resourceError.kind === 'generic'"
        (backEvent)="goBack($event)"
        (retryEvent)="getDetail()"
    />
}

@if (detail && showModalChangeStatus) {
    <app-modal-change-status
        [id]="detail.process_uuid"
        [status]="detail.status_process"
        (closeEvent)="closeChangeStatus($event)"
    />
}

<app-developer-curl-button #menuCurlBtn [showButton]="false" />

@if (detail && showModalBlockIdentity) {
    <app-modal-block-identity
        [id]="detail?.identity?.uuid"
        [locks]="detail?.locks"
        [showOcrBlockOption]="!!detail?.identity?.identifier"
        [showFaceBlockOption]="!!detail?.data?.POL"
        [selectedOptions]="selectedOptionsIdentity"
        (closeEvent)="closeBlockIdentity($event)"
    />
}

@if (detail && showModalUnlockIdentity) {
    <app-modal-unlock-identity
        [id]="detail?.identity?.uuid"
        [locks]="detail?.locks"
        [showOcrUnlockOption]="!!detail?.identity?.identifier"
        [showFaceUnlockOption]="!!detail?.data?.POL"
        [selectedOptions]="selectedOptionsIdentity"
        (closeEvent)="closeUnlockIdentity($event)"
    />
}

@if (detail && showModalIdentityDetail) {
    <app-modal-identity-process-detail
        [identity]="detail.identity"
        [fullName]="fullName"
        [yearsOld]="processHelper.ocrDocumentAgeKnown ? processHelper.yearsOld : null"
        [nationalityFallback]="detail?.data?.OCR?.nationality"
        (closeEvent)="showModalIdentityDetail = false"
    />
}

@if (showModalEditIdentity && identityDetailForEdit) {
    <app-modal-edit-identity
        [detail]="identityDetailForEdit"
        [alwaysAttachProcessUuid]="true"
        (closeEvent)="closeEditIdentity($event)"
    />
}

@if (detail && showModalJsonViewer) {
    <app-modal-json-viewer
        [title]="'PROCESSES.DETAIL.MODAL_JSON_VIEWER_TITLE' | translate"
        [json]="detail"
        (closeEvent)="showModalJsonViewer = false"
    ></app-modal-json-viewer>
}
<!-- MODAL USER AGENT (detalle navegador) -->
@if (deviceForUserAgentModal) {
    <app-modal-user-agent
        [device]="deviceForUserAgentModal"
        (closeEvent)="closeUserAgentModal()"
    />
}

@if (showSentMessagesModal()) {
    <app-modal-sent-messages
        [sms]="detail?.general?.sms || []"
        [whatsapp]="detail?.general?.whatsapp || []"
        (closeEvent)="closeSentMessagesModal()"
    />
}

<!-- MODAL POLICY CHECKS -->
@if (policyModalInfo) {
    <tec-modal
        [isVisible]="true"
        [title]="'PROCESSES.DETAIL.LEGAL_TERM' | translate"
        (closeEvent)="policyModalInfo = null">
        <ng-container body>
            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.NAME' | translate">
                    <span>{{ policyModalName(policyModalInfo) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'LEGAL_TERMS.REQUIRED' | translate">
                    <span>{{ policyModalInfo.required ? ('GENERAL.YES' | translate) : ('GENERAL.NO' | translate) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.POLICY_ORIGIN' | translate">
                    <span>{{ policyModalOrigin(policyModalInfo) }}</span>
                </tec-info-group>
            </div>
            <tec-tile>
                <span [innerHTML]="policyModalInfo.html"></span>
            </tec-tile>
        </ng-container>
    </tec-modal>
}


<ng-template #BLOCK_UNLOCK_ICONS let-defaultBlocks="defaultBlocks" let-defaultUnblocks="defaultUnblocks">
    @for (menu of processHelper.detailMenuOpt(detail, false); track $index) {
        @if (menu.id === menuItemAction.BLOCK) {
            <tec-button-icon
                icon="icon-lock"
                size="sm"
                [tooltip]="'BUTTON.BLOCK' | translate"
                (click)="detailMenuChange(menu, defaultBlocks || [])"
            />
        }
        @if (menu.id === menuItemAction.UNLOCK) {
            <tec-button-icon
                icon="icon-unlock"
                size="sm"
                [tooltip]="'BUTTON.UNBLOCK' | translate"
                (click)="detailMenuChange(menu, defaultUnblocks || [])"
            />
        }
    }
</ng-template>